import { Account } from '@/domain/usecases'
import { dependentRequestService } from '@/data/services/dependent/dependent-service'
import { formatDependentRequestSettings } from '@/data/services/dependent/dependent-service-utils'
import { requestSettingsQueryOptions } from '@/data/services/request-settings/request-settings-service'
import { queryClient } from '@/infra/http'

/**
 * Loads dependent request data
 * Fetches dependent settings and pending requests for user's company
 */
export async function loadDependentRequest(account: Account.Model) {
  const [settings, dependentRequestStatus] = await Promise.all([
    queryClient.fetchQuery(requestSettingsQueryOptions(account.company.uniqueId)),
    dependentRequestService.fetchPendingRequests(account.company.uniqueId)
  ])

  const dependentSettings = formatDependentRequestSettings(settings)
  const plans = dependentSettings.plans?.filter(plan => plan.enabled) ?? []
  const degreesKinship = dependentSettings.degreesKinship?.filter(degree => degree.allowed) ?? []

  return {
    ...dependentSettings,
    plans,
    degreesKinship,
    pendingResponse: dependentRequestStatus
  }
}
